import React, { useState } from "react";
import Tabs from "@/components/common/Tabs";
import SettingsProfile from "./tabs/SettingsProfile";
import SettingsBranding from "./tabs/SettingsBranding";
import SettingsSecurity from "./tabs/SettingsSecurity";

const SponsorSettings = () => {
  const [activeTab, setActiveTab] = useState("profile");

  const tabs = [
    { id: "profile", label: "Profile Info" },
    { id: "branding", label: "Branding" },
    { id: "security", label: "Security" },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
          Settings
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Manage your company profile, branding, and account settings
        </p>
      </div>

      {/* Tabs */}
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === "profile" && <SettingsProfile />}
        {activeTab === "branding" && <SettingsBranding />}
        {activeTab === "security" && <SettingsSecurity />}
      </div>
    </div>
  );
};

export default SponsorSettings;
